"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canvaInitAttempted = canvaInitAttempted;
exports.canvaInitSucceeded = canvaInitSucceeded;
exports.canvaInitFailed = canvaInitFailed;
exports.acquireFileFromCanva = acquireFileFromCanva;
exports.getFileNameForCanvaDesign = void 0;

var FileApi = _interopRequireWildcard(require("../api/Files"));

var _notifications = require("../utils/notifications");

var _Constants = require("../Constants");

var _ActionTypes = require("./ActionTypes");

var _Canva = require("../constants/Canva");

var _FolderFetch = require("./FolderFetch");

var _tracking = require("./tracking");

var _logging = require("../utils/logging");

function canvaInitAttempted() {
  return {
    type: _ActionTypes.CANVA_INIT_ATTEMPTED
  };
}

function canvaInitSucceeded() {
  return {
    type: _ActionTypes.CANVA_INIT_SUCCEEDED
  };
}

function canvaInitFailed() {
  return {
    type: _ActionTypes.CANVA_INIT_FAILED
  };
}

function canvaDownloadAttempted(_ref) {
  var meta = _ref.meta;
  return {
    type: _ActionTypes.DOWNLOAD_FROM_CANVA_ATTEMPTED,
    meta: meta
  };
}

function canvaDownloadFailed(_ref2) {
  var meta = _ref2.meta;
  return {
    type: _ActionTypes.DOWNLOAD_FROM_CANVA_FAILED,
    meta: meta
  };
}

function canvaDownloadSucceeded(_ref3) {
  var file = _ref3.file,
      meta = _ref3.meta;
  return {
    type: _ActionTypes.DOWNLOAD_FROM_CANVA_SUCCEEDED,
    file: file,
    meta: meta
  };
}

function removeCanvaIdSucceeded(_ref4) {
  var file = _ref4.file;
  return {
    type: _ActionTypes.REMOVE_CANVA_ID_SUCCEEDED,
    file: file
  };
}

var getFileNameForCanvaDesign = function getFileNameForCanvaDesign(fileName, canvaDesignId) {
  if (!fileName || fileName === _Canva.CANVA_DEFAULT_DESIGN_NAME) {
    return _Canva.CANVA_DEFAULT_FILE_TITLE + " " + canvaDesignId;
  }

  return fileName;
};

exports.getFileNameForCanvaDesign = getFileNameForCanvaDesign;

function acquireFileFromCanva(_ref5) {
  var canvaDesignId = _ref5.canvaDesignId,
      fileUrl = _ref5.fileUrl,
      folder = _ref5.folder,
      originalFileId = _ref5.originalFileId,
      fileName = _ref5.fileName,
      uploadedFileAccess = _ref5.uploadedFileAccess;
  return function (dispatch, getState, httpClient) {
    var fileDownloadOptions = {
      name: getFileNameForCanvaDesign(fileName, canvaDesignId),
      url: fileUrl
    };

    if (folder) {
      fileDownloadOptions.folderId = folder.get('id');
    } else {
      fileDownloadOptions.folderPath = _Constants.CanvaFolderPath;
    }

    dispatch(canvaDownloadAttempted({
      meta: (0, _tracking.getTrackingMeta)('Manage Files', 'upload-canva-attempt')
    }));
    return FileApi.downloadFromUrl(fileDownloadOptions, fileUrl, uploadedFileAccess, httpClient).then(function (newCanvaFile) {
      FileApi.setCanvaId(newCanvaFile.get('id'), canvaDesignId, httpClient).then(function (updatedCanvaFile) {
        dispatch(canvaDownloadSucceeded({
          file: updatedCanvaFile,
          meta: (0, _tracking.getTrackingMeta)('Manage Files', 'upload-canva-success')
        }));

        if (!folder && newCanvaFile.get('folder_id')) {
          dispatch((0, _FolderFetch.fetchFolderById)(newCanvaFile.get('folder_id')));
        }
      });

      if (originalFileId) {
        FileApi.removeCanvaId(originalFileId, httpClient).then(function (updatedOriginalFile) {
          dispatch(removeCanvaIdSucceeded({
            file: updatedOriginalFile
          }));
        });
      }
    }).catch(function (error) {
      (0, _logging.reportError)(error, {
        action: _ActionTypes.DOWNLOAD_FROM_CANVA_FAILED
      });
      dispatch(canvaDownloadFailed({
        meta: {
          notification: (0, _notifications.getCanvaDownloadFailedNotification)()
        }
      }));
    });
  };
}